<template>
  <AssessmentModeSelection  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AssessmentModeSelection from '../components/AssessmentModeSelection.vue';
import { clearActiveTextModeContext } from '@/features/text-mode/analytics/text-mode-context';

import '../styles/assessment.css';

export default defineComponent({
  name: 'AssessmentEntryPage',

  components: {
    AssessmentModeSelection,
  },

  setup() {
    clearActiveTextModeContext();
    return {};
  },
});
</script>